import * as i0 from '@angular/core';
import { Injectable, APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

class DynamicConfigParams {
}

class DynamicConfigService {
    constructor(http, configParams) {
        this.http = http;
        this.configParams = configParams;
    }
    get() {
        return this.config;
    }
    load() {
        return this.http.get(this.configParams.src, { headers: { noToken: 'noToken' } }).pipe(map(d => {
            this.config = d;
            return d;
        }), shareReplay(1));
    }
}
DynamicConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DynamicConfigService, deps: [{ token: i1.HttpClient }, { token: DynamicConfigParams }], target: i0.ɵɵFactoryTarget.Injectable });
DynamicConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DynamicConfigService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DynamicConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: DynamicConfigParams }]; } });

function loadConfigProvider(config) {
    return () => config.load().toPromise();
}
// @dynamic
class DynamicConfigModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('DynamicConfigModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(config) {
        return {
            ngModule: DynamicConfigModule,
            providers: [{ provide: DynamicConfigParams, useValue: config || { src: '/config.json' } }]
        };
    }
}
DynamicConfigModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DynamicConfigModule, deps: [{ token: DynamicConfigModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
DynamicConfigModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DynamicConfigModule, imports: [HttpClientModule] });
DynamicConfigModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DynamicConfigModule, providers: [
        DynamicConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: loadConfigProvider,
            deps: [DynamicConfigService],
            multi: true
        }
    ], imports: [HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DynamicConfigModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [HttpClientModule],
                    providers: [
                        DynamicConfigService,
                        {
                            provide: APP_INITIALIZER,
                            useFactory: loadConfigProvider,
                            deps: [DynamicConfigService],
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: DynamicConfigModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/*
 * Public API Surface of dynamic-config
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DynamicConfigModule, DynamicConfigParams, DynamicConfigService, loadConfigProvider };
